import Sidebar from "../components/Sidebar";

export default function BlockDashboard() {
  return (
    <div className="dashboard-container">
      <Sidebar />
      <div className="dashboard-content">
        <h1>Block Coordinator Dashboard</h1>
        <p>Welcome Block Coordinator</p>
      </div>
    </div>
  );
}